var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import api from '@utils/axios';
import I18n from '@utils/i18n';
import toast from 'react-hot-toast';
import { setPendingToast } from '@utils/pendingToast';
import { proposedCorrectionPath, proposedCorrectionsPath } from '@routes';
import { SaveFailure } from './types';
const UNAUTHORIZED = 401;
export function useProposedCorrectionSubmit(id) {
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState(null);
    const [saveFailure, setSaveFailure] = useState(null);
    const submit = (_a) => __awaiter(this, [_a], void 0, function* ({ formData, priceLevels }) {
        var _b;
        setSubmitting(true);
        setErrors(null);
        setSaveFailure(null);
        const payload = {
            proposed_correction: Object.assign(Object.assign({}, formData), { price_levels_attributes: priceLevels.map((pl) => ({
                    id: pl.id || undefined,
                    name: pl.name,
                    price: pl.price,
                    active: pl.active
                })) })
        };
        try {
            yield api.patch(`${proposedCorrectionPath(id)}.json`, payload);
            // A full-page redirect tears down this page (and any toast rendered on
            // it) before the toast can display. Queue it for the destination page's
            // toaster to show instead, so the confirmation survives the navigation.
            setPendingToast(I18n.t('proposed_corrections.update.success_message'));
            window.location.href = proposedCorrectionsPath();
        }
        catch (error) {
            const { status, data } = (_b = error.response) !== null && _b !== void 0 ? _b : {};
            if (status === UNAUTHORIZED || (data === null || data === void 0 ? void 0 : data.session_expired) === true) {
                setSaveFailure(SaveFailure.SESSION_EXPIRED);
            }
            else if (typeof (data === null || data === void 0 ? void 0 : data.error) === 'string') {
                toast.error(data.error, { position: 'bottom-right' });
            }
            else if (data === null || data === void 0 ? void 0 : data.error) {
                setErrors(Array.isArray(data.error) ? { base: data.error } : data.error);
            }
            else if (data === null || data === void 0 ? void 0 : data.errors) {
                setErrors(data.errors);
            }
            else {
                setSaveFailure(SaveFailure.UNEXPECTED);
            }
        }
        finally {
            setSubmitting(false);
        }
    });
    return { submitting, errors, saveFailure, submit };
}
